export default __webpack_public_path__ + "static/Magazzini-aa28d1a45900bfbf5988d60a97c9dee3.jpg";